import { TPaymentScheduleStatus } from '@/shared/api';
import { theme } from '@/shared/theme';

export const getScheduleColor = (status: TPaymentScheduleStatus): string => {
    switch (status) {
        case 'pay_day':
        case 'current':
            return theme.color.primary;

        case 'outstanding':
            return theme.color.dark;

        case 'overdue':
            return theme.color.error;

        case 'completed':
        default:
            return theme.color.neutral300;
    }
};
